var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.option.hide)?_c('div',{class:_vm.setClass(),style:(_vm.styleSize)},[(_vm.option.source)?_c('img',{class:{'drag-image-rotate' : _vm.option.animation},style:(_vm.styleImage),attrs:{"src":`${_vm.FDFS_WEB_SERVER_URL + _vm.option.source}`,"draggable":"false"}}):_c('i',{staticClass:"xa-icon xa-icon-picture drag-image-placeholder"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }